import { render } from "./FilterVerticalComponent.vue?vue&type=template&id=fddf18fc&scoped=true"
import script from "./FilterVerticalComponent.vue?vue&type=script&lang=js"
export * from "./FilterVerticalComponent.vue?vue&type=script&lang=js"

import "./FilterVerticalComponent.vue?vue&type=style&index=0&id=fddf18fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fddf18fc"]])

export default __exports__